// @ts-nocheck
/* eslint-enable */
// Action creators
import { FilterActions_fetchFilterFromUrlAndApi } from 'app/shared/flux/actions/FilterActions';
import AreaActions from 'app/shared/flux/actions/AreaActions';
import ListingEngineActions from 'app/shared/flux/actions/ListingEngineActions';

// Misc / Utils
import CONSTANTS from 'app/shared/constants/ValueConstants';
import { getGlobalLogger } from '@zg-rentals/logger-base';
import { logError } from '@zg-rentals/log-error';

const logger = getGlobalLogger('template/searchresultspage/serverroutewillmount');

export const srwmFetchFilterFromUrlAndApi = (reactContext) => {
  const { state, store } = reactContext;
  const { pathname, query } = state;

  return store
    .dispatch(FilterActions_fetchFilterFromUrlAndApi(pathname, query))
    .then((res) => {
      if (res.error) {
        return {
          changeHttpStatus: 404,
        };
      }
      return res;
    })
    .catch((err) => {
      logError({ error: err, context: 'error in SearchResultsPage#srwmFetchFilterFromUrlAndApi' });
    });
};

export const srwmFetchAreaDataByResourceId = (reactContext, { areaResourceId: resourceId }) => {
  const { store } = reactContext;

  return store
    .dispatch(AreaActions.fetchAreaDataByResourceId(resourceId))
    .then((res) => {
      if (res.error) {
        return {
          changeHttpStatus: 404,
        };
      }

      return res;
    })
    .catch((err) => {
      logError({ error: err, context: 'error in SearchResultsPage#srwmFetchAreaDataByResourceId' });
    });
};

export const srwmFetchListingsAndOtherData = (reactContext) => {
  const { store } = reactContext;
  const { query } = reactContext.state;
  const promises = [];
  const currState = store.getState();
  const page = query.page ? Math.max(query.page, 0) : 0;
  //HPWEB-5917 - state pages sorted by newest
  const areaType = currState?.area?.area?.type;
  if (areaType === 'state') {
    currState.filter.orderBy = 'activated';
  }
  //end HPWEB-5917
  const byCoordsAndHistogramParams = {
    filter: currState.filter,
    page,
  };

  const seoFooterLinksParams = {
    resourceId: currState.area.area.resourceId,
    searchSlug: currState.filter.search.slug,
  };

  // Promises will be called in parallel
  promises.push(
    // Listings
    store.dispatch(ListingEngineActions.fetchListingsOnlyByCoords(byCoordsAndHistogramParams)),
    // Area histogram data (not to be confused w/ price filter histogram data)
    store.dispatch(AreaActions.fetchPriceHistogramData(byCoordsAndHistogramParams)),
    // SEO footer links
    store.dispatch(AreaActions.loadAreaSeoLinks(seoFooterLinksParams)),
    // Area articles (requred for all slugs for SEO reasons)
    store.dispatch(AreaActions.loadArticles(currState.area.area.resourceId)),
    store.dispatch(AreaActions.loadFacts(currState.area.area.resourceId)),
    store.dispatch(AreaActions.loadFactsByBeds(currState.area.area.resourceId)),
  );

  return promises;
};

export const srwmCheckAndFetchNearbyListings = (reactContext) => {
  const { store } = reactContext;
  const latestState = store.getState();
  const maxBuildings = latestState.listings.totalBuildings;
  const maxPage = Math.max(Math.ceil(maxBuildings / CONSTANTS.MAX_LISTINGS_PER_PAGE), 1);
  const currentPage = latestState.location.current && latestState.location.current.query.page;
  const onLastPage = maxPage === Number(currentPage) || (maxPage === 1 && !currentPage);

  if (onLastPage) {
    const areaResourceId = latestState.area.area.resourceId;
    return store.dispatch(ListingEngineActions.fetchNearbyAreasListingsForMobileSRP(areaResourceId));
  }

  return Promise.resolve({ success: true });
};
